import { render } from "./Resend.vue?vue&type=template&id=98abaa54&scoped=true"
import script from "./Resend.vue?vue&type=script&lang=js"
export * from "./Resend.vue?vue&type=script&lang=js"

import "./Resend.vue?vue&type=style&index=0&id=98abaa54&scoped=true&lang=css"

import exportComponent from "/Users/masayukitenma/Documents/Develop/Container/claudedocs/l13-check/fe-build/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98abaa54"]])

export default __exports__